.container {
  position: relative;
  cursor: pointer;
  display: flex;
  width: 100%;
  padding: var(--space-xs);
  border-radius: var(--border-radius-xs);
  align-items: center;
  transition: background-color 0.15s ease-in-out;

  .details {
    display: flex;
    align-items: center;
  }

  .subtitle {
    display: block;
    color: var(--color-accent-1);
    font-size: 0.8em;
  }

  .thumbnail {
    flex-grow: 0;
    flex-shrink: 0;
    width: 80px;
    margin-right: var(--space-s);
    position: relative;

    &.noImage::after {
      color: red;
      content: "No image";
      text-transform: uppercase;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  }

  .title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .button {
    position: absolute;
    top: 50%;
    right: var(--space-xs);
    opacity: 0;
    transition: transform 0.15s ease-in-out, opacity 0.15s ease-in-out;
  }

  &.selected:not(.draggable) {
    background: rgb(176, 196, 205, 10%);
  }

  &:hover,
  &.selected:not(.draggable) {
    .button {
      transform: translateY(-50%);
      opacity: 1;
    }
  }

  &:hover,
  &.selected:not(.draggable):hover {
    background: rgb(176, 196, 205, 35%);
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
